/*
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
gsap.registerPlugin(ScrollToPlugin, Draggable, InertiaPlugin);
*/

import { debounce as _debounce } from 'underscore';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import '@benmajor/jquery-touch-events';
import slideshowCtrl        from './slideshowCtrl';


export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                   false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module_history';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);

       

        this.initSlider(true);
        
	}

    initSlider(b){
        let $s =  this.$el.find( '.module-slider-container' ), args;
        if ( b ){

            this.slides = [];
            this.$el.find( '.slide' ).each( (i, el) => {
                this.slides[i] = $(el);
            });

            this.onResize();

            /*
            $s.find( '.slick-slider' ).on( 'beforeChange', (event, slick, currentSlide, nextSlide) =>{
                
            });
            */
            $s.find( '.slick-slider' ).on( 'afterChange', (event, slick, currentSlide ) =>{
                this.setMenuIndexAfterSLideChange( currentSlide );
            });

            args = {
                dots: false,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                centerMode: false,
                variableWidth: true,
                arrows: true,
                autoplay: false,
                prevArrow : $s.find('.arrow.left'),
                nextArrow : $s.find('.arrow.right'),

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: false                      
                        }
                    }
                ]
            }
            // important: Remember to pass the dom element!!!
            this.slider = new slideshowCtrl( {
                $el : $s,
                customArgs: true,
                args: args
            });

            setTimeout( ()=>this.delayInit(), 100 );

            this.setMenuIndex(0);
           

        }
        else{
            this.slider.destroy();
        }

        this.addEvents( b );       
    }

    delayInit(){
        this.$el.find( '.module-slider-container' ).addClass( 'ready' );
    }

    addEvents(b){
        if ( b ){
            this.$el.find( '.menu a' ).on( 'click', (e) => {this.onSelectMenu(e)} );
            this.$el.find( '.slide' ).on( 'tap', (e)=>this.onSlideTap(e) );
            this.$el.find( '#mobile-text-window .close' ).on( 'tap', ()=>this.openWindowCaptions(false) );
        }
        else{
            this.$el.find( '.menu a' ).off( 'click', (e) => {this.onSelectMenu(e)} );
            this.$el.find( '.slide' ).off( 'tap', (e)=>this.onSlideTap(e) );
            this.$el.find( '#mobile-text-window .close' ).off( 'tap', ()=>this.openWindowCaptions(false) );
        }

        this.debounceResize(b);
    }

    //--------------------- MOBILE CAPTIONS -------------------------------//
    onSlideTap(e){
        let $slide = $(e.currentTarget), $w = this.$el.find( '#mobile-text-window' );
        $w.find( '.text' ).html( $slide.find( '.text-scroll' ).html() );
        this.openWindowCaptions( true )
    }
    openWindowCaptions(b){
        let $w = this.$el.find( '#mobile-text-window' ); 
        if ( b ){
            if ( !$w.hasClass( 'open' ) ){
                $w.addClass( 'open' );
            }
        }
        else{
             if ( $w.hasClass( 'open' ) ){
                $w.removeClass( 'open' );
            }
        }
    }
    //--------------------- END OBILE CAPTIONS -------------------------------//

    onSelectMenu(e){
        e.preventDefault();

        let $li = $(e.currentTarget).parent(), index, i, $s;
        
        if ( $li.length > 0 ){
            index = $li.attr( 'data-index-year' );
            for( i=0; i<this.slides.length; i++ ){
                $s = this.slides[ i ];
                if ( $s.attr( 'data-index-year' ) === index ){
                    this.setSliderIndex( i );
                    break;
                }
            }
        }
    }

    setSliderIndex( i ){
        let $slick = this.slider.getSlider();
        $slick.slick( 'slickGoTo', i );
    }

    setMenuIndexAfterSLideChange( currentSlide ){
        let $s = this.slides[ currentSlide ], year;
        if ( $s.length > 0 ){
            year = $s.attr( 'data-index-year' );
        }
        this.setMenuIndex( year );
    }
    setMenuIndex( index ){
        let $m;
        this.$el.find( '.menu' ).each((i,el)=>{
            $m = $(el);
            $m.find( 'li' ).removeClass( 'current-menu-item' );
            $m.find( 'li' ).eq( index ).addClass( 'current-menu-item' );
        })
    }





    //---------------------------------------- COMMONS -----------------------------------------//
    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 137 );
            this.$win.on( 'resize', this._debResize );

            setTimeout( () => this.onResize(), 200 );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){
        let $imgWrap, orw, orh, fixh;
        this.$el.find( '.slide' ).each( (i,el) => {

            $imgWrap = $(el).find( '.img-wrapper' );
            orw  = parseInt( $imgWrap.attr( 'data-width' ) );
            orh  = parseInt( $imgWrap.attr( 'data-height' ) );
            fixh = $imgWrap.parents( '.layout' ).height();

            $imgWrap.css({
                'height': fixh,
                'padding-bottom': '0%',
                'width': orw/orh*fixh
            })

        });
    }


    destroy(){
		if ( this.$el.length > 0){
            this.initSlider( false );
    	}
    }

}


